import { CenterScreenModal } from '../atoms'
import { useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks'
import { CreateTenantForm } from '../organism';
import { Col, Row } from 'react-grid-system';
import { FetchResult } from '@apollo/client';
import { CreateTenantMutation, UpdateTenantMutation } from '@/graphql/generated';

const textsData = {
  en: {
    title: 'Create a Tenant',
    confirmation: {
      create: {
        title: 'Tenant has been created',
        description: (firstName: string, lastName: string) => `User ${firstName} ${lastName} has been created succesfully`,
      },
      update: {
        title: 'Tenant has been updated',
        description: (firstName: string, lastName: string) => `User ${firstName} ${lastName} has been updated succesfully`,
      }
    }
  },
  es: {
    title: 'Crear a un Inquilino',
    confirmation: {
      create: {
        title: 'Inquilino creado con éxito',
        description: (firstName: string, lastName: string) => `${firstName} ${lastName} fue creado con éxito`,
      },
      update: {
        title: 'Inquilino actualizado con exito',
        description: (firstName: string, lastName: string) => `${firstName} ${lastName} fue actualizado con éxito`,
      }
    }
  }
}

export const CreateTenantFormModal = () => {
  const { state, createTenantFormModalClose, confirmDialogModalOpen} = useOpeningElementsControllerContext();

  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const onCreateSuccess = (response: FetchResult<CreateTenantMutation> | FetchResult<UpdateTenantMutation>) => {
    if (response.data && 'createTenant' in response.data) {
      const user = response.data?.createTenant
      if (user.__typename === 'TenantOutput') {
        createTenantFormModalClose()
        confirmDialogModalOpen({
          title: texts.confirmation.create.title,
          description: texts.confirmation.create.description(user.firstName, user.lastName),
        })
      }
    }
    else if (response.data && 'updateTenant' in response.data) {
      const user = response.data?.updateTenant
      createTenantFormModalClose()
      confirmDialogModalOpen({
        title: texts.confirmation.update.title,
        description: texts.confirmation.update.description(user.firstName, user.lastName)
      })
    } 
  }

  return (
    <CenterScreenModal
      isOpen={state.isCreateTenantFormModalOpen}
      onClose={createTenantFormModalClose}
    >
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <CreateTenantForm
        tenantDetail={null}
        activity="creating"
        onSuccess={onCreateSuccess}
      />   
    </CenterScreenModal>
  )
}
